export default __webpack_public_path__ + "static/media/Instagram.76727491.png";